import {ReactNode} from 'react';

import {view} from '@sail/ui';

import {AssistantContainer} from '@stripe-internal/conversations-assistant';

import {MobileDevHeader} from './MobileDevHeader';

export function MobileAssistantContainer({children}: {children: ReactNode}) {
  return (
    <view.div css={{height: '100vh'}}>
      <AssistantContainer header={<MobileDevHeader />} footer={null}>
        {children}
      </AssistantContainer>
    </view.div>
  );
}
